import * as React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { settingActions, settingObj } from '../store/SettingSlice';
import $ from 'jquery';
import * as JSTool from '../store/JSTool';

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';
import { Autoplay, EffectFade } from 'swiper/modules';

export default function Page2(props) {

    const settingData = useSelector(state => state.settingData);
    const dispatch = useDispatch();
    const [swp, setSwp] = React.useState(null);

    const iconAry = ['map-thumb-03.webp', 'map-thumb-04.webp', 'map-thumb-01.webp', 'map-thumb-02.webp', 'map-thumb-05.webp', 'map-thumb-06.webp'];
    const videoAry = ['map/map1.mp4', 'map/map2.mp4', 'map/map3.mp4', 'map/map4.mp4', 'map/map5.mp4', 'map/map6.mp4'];
    const posterAry = ['map/poster1.png', 'map/poster2.png', 'map/poster3.png', 'map/poster4.png', 'map/poster5.png', 'map/poster6.png'];
    const logoAry = ['map/map_l_3.png', 'map/map_l_4.png', 'map/map_l_1.png', 'map/map_l_22.png', 'map/map_l_5.png', 'map/map_l_6.png'];

    React.useEffect(() => {

    }, []);

    function indexChanged() {
        if (swp) {
            let video = document.getElementById(`map_video_${swp.realIndex}`);
            video.currentTime = 0; // 设置播放到第 0 秒
            dispatch(settingActions.setMapIndex(swp.realIndex));
        }
    }

    function itemTap(index) {
        if (swp) {
            swp.slideToLoop(index);
        }
    }

    return (
        <Stack sx={{
            width: 1,
            height: settingData.height,
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            bgcolor: 'black'
        }}>

            <Swiper style={{
                height: '100%',
                width: '100%'
            }}
                effect={'fade'}
                loop={true}
                slidesPerView={1}
                modules={[Autoplay, EffectFade]}
                centeredSlides={true}
                slideToClickedSlide={true}

                autoplay={{
                    delay: 7000,
                    disableOnInteraction: false,
                }}

                onActiveIndexChange={(sp) => {
                    indexChanged();
                }}

                onSwiper={(swiper) => {
                    setSwp(swiper);
                }}>

                {
                    videoAry.map((data, index) => {
                        return (
                            <SwiperSlide key={index}>
                                <Box
                                    id={`map_video_${index}`}
                                    component={'video'}
                                    autoPlay={true}
                                    loop={true}
                                    muted={true}
                                    playsInline={true}
                                    disablePictureInPicture={true}
                                    poster={JSTool.getImgPath(posterAry[index])}
                                    src={JSTool.getImgPath(videoAry[index])}
                                    sx={{
                                        width: 1,
                                        height: 1,
                                        objectFit: 'cover',
                                    }} />
                            </SwiperSlide>
                        )
                    })
                }

            </Swiper>

            <Stack sx={{
                zIndex: 2,
                position: 'absolute',
                width: 1,
                height: 1,
                alignItems: 'center',
                justifyContent: 'center',
            }}>
                <Stack sx={{
                    position: 'absolute',
                    width: 1,
                    height: '100rem',
                    bottom: settingData.isMobile ? '150rem' : '80rem',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                }}>
                    {iconAry.map((item, index) => {
                        return (
                            <Item key={index} index={index} item={item} itemTap={itemTap} />
                        );
                    })}

                </Stack>
            </Stack>

            <Box component={'img'}
                src={JSTool.getImgPath(logoAry[settingData.mapIndex])}
                sx={{
                    width: '350rem',
                    height: '350rem',
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    margin: 'auto',
                    zIndex: 10,
                }} />

        </Stack>
    );
}

function Item(props) {
    const settingData = useSelector(state => state.settingData);
    const dispatch = useDispatch();

    return (
        <Box
            onClick={() => {
                props.itemTap(props.index);
            }}

            component={'img'}
            src={JSTool.getImgPath(props.item)}
            sx={{
                width: '85rem',
                mx: settingData.isMobile ? 0 : 1.5,
                opacity: settingData.mapIndex == props.index ? 1 : 0.4,
                cursor: 'pointer',
                transitionDuration: '0.3s',
                '&:hover': {
                    transform: 'scale(1.2)',
                },
            }} />
    );
}